import { Button, Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";

const GiaNumber = ({
  giainputError,
  handleGIAInput,
  handleSubmit,
  isActive,
  giainputTextError
}) => {
  //const inputRef = useRef(null);
  //console.log("giainputError =>", giainputError)

  const handleSubmitChange = (event) => {
    event.preventDefault(); 
  };


  return (
    <div
      className="diamond-weight-wrapper diamond-weight-container"
      id="diamondWeight"
    >
      <h5>TYPE IN THE GIA NUMBER</h5>
      <Form onSubmit={handleSubmitChange}>
        <Form.Group
          className={`diamond-weight ${giainputError ? "error-2" : ""}`}
        >
          <Form.Label></Form.Label>
          <Form.Control
            type="number"
            placeholder="Enter Number"
            pattern="/^\d{7,10}$/"
            name="number"
            onChange={(e) => handleGIAInput(e)}
            //ref={inputRef}
            autoFocus={true}
          />
          {giainputTextError && (
          <span className="error-text">Please check the number you entered</span>
        )}
        </Form.Group>
        <div className="rarity-process-content rarity-gia-btn">
          <Button
            className="processBtn"
            disabled={(giainputError)}
            onClick={() => handleSubmit("fromgia")}
            type="submit"
          >
            {isActive ? <Spinner animation="border" /> : "Generate"}
          </Button>
        </div>
      </Form>
    </div>
  );
};
export default GiaNumber;
